export const API_BASE_PATH =
  process.env.NODE_ENV === 'production' ? 'https://lk.wiseplus.ru' : 'http://192.168.1.21:8001'
